/**
 * WorthSparkline — tiny inline SVG polyline of a value series.
 * 2026-07-21 (owner request) — sits beside the Stage Portfolio row so
 * players see their roster's market value trend at a glance.
 */

import { memo } from 'react';

export function sparkPoints(series, width = 96, height = 28, pad = 2) {
  const vals = (series || []).map((p) => p.value);
  if (vals.length < 2) return '';
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const span = max - min || 1;
  const stepX = (width - pad * 2) / (vals.length - 1);
  return vals
    .map((v, i) => {
      const x = pad + i * stepX;
      const y = pad + (height - pad * 2) * (1 - (v - min) / span);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
}

function WorthSparkline({ series, width = 96, height = 28 }) {
  if (!series || series.length < 2) return null;
  const up = series[series.length - 1].value >= series[0].value;
  const stroke = up ? 'hsl(var(--positive-text))' : 'hsl(var(--destructive))';
  return (
    <svg width={width} height={height} data-testid="worth-sparkline" aria-hidden>
      <polyline
        points={sparkPoints(series, width, height)}
        fill="none"
        style={{ stroke }}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
// 2026-07-21 audit — memo: StageTab re-renders on every floater tick; the
// sparkline's series only changes on refetch, so skip the SVG re-render.
export default memo(WorthSparkline);
